import { property, propertyOf, omit } from 'underscore';

import { addOutcomes, removeOutcomes } from 'sportsbook-outcomes-duck';
import { addMarkets, removeMarkets } from 'sportsbook-markets-duck';
import fetchData from './api';

export const UPCOMING_RACES_FETCH_DATA_INIT = 'upcomingRaces/UPCOMING_RACES_FETCH_DATA_INIT';
export const UPCOMING_RACES_FETCH_DATA_SUCCESS = 'upcomingRaces/UPCOMING_RACES_FETCH_DATA_SUCCESS';
export const UPCOMING_RACES_RESET = 'upcomingRaces/UPCOMING_RACES_RESET';

export const upcomingRacesFetchDataInit = (componentId) => ({
  type: UPCOMING_RACES_FETCH_DATA_INIT,
  componentId,
});

export const upcomingRacesFetchDataSuccess = (componentId) => (events, config) => ({
  type: UPCOMING_RACES_FETCH_DATA_SUCCESS,
  componentId,
  events,
  config,
});

export const upcomingRacesResetSuccess = (componentId) => ({
  type: UPCOMING_RACES_RESET,
  componentId,
});

export const upcomingRacesReset = (componentId) => () => (dispatch, getState) => {
  const { events = [] } = getState().upcomingRaces.componentsById[componentId];

  // Should we better keep the list of market ids and outcome ids in upcoming races state?
  const marketIds = events.map(property('market_id'));
  const outcomeIds = marketIds.map(propertyOf(getState().markets)).flatMap(property('o'));

  dispatch(removeOutcomes(outcomeIds));
  dispatch(removeMarkets(marketIds));
  dispatch(upcomingRacesResetSuccess(componentId));
};

const getConfig = (data) => data?.config && ({
  ...data.config,
  outcomesNumber: data.markets?.[0]?.o?.length || 0,
});

export const upcomingRacesFetchData = (componentId) => () => (dispatch) => {
  dispatch(upcomingRacesFetchDataInit(componentId));
  return fetchData(componentId)
    .then((data) => {
      dispatch(addOutcomes(data.outcomes));
      dispatch(addMarkets(data.markets));
      dispatch(upcomingRacesFetchDataSuccess(componentId)(data.events, getConfig(data)));
    });
};

const initialState = {
  componentsById: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case UPCOMING_RACES_FETCH_DATA_SUCCESS:
      return {
        componentsById: {
          ...state.componentsById,
          [action.componentId]: {
            events: action.events,
            config: action.config,
            loaded: true,
          },
        },
      };
    case UPCOMING_RACES_RESET:
      return {
        componentsById: {
          ...omit(state.componentsById, action.componentId),
        },
      };
    default:
      return state;
  }
};
